import React from 'react';
import Title from '../../components/title/Title';
import { Spinner, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { formatNumber, formatDateMin } from '../../misc/index';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faCheckCircle } from '@fortawesome/free-regular-svg-icons';
import { faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import { faFilePdf } from '@fortawesome/free-regular-svg-icons';
import { Link } from 'react-router-dom';
import DateField from '../../components/dateField';
import Button from '../../components/button/Button';
import './Facturas.css'

const IconoEstado = (props) => {
    return(
        <>
            { props.estado > 0 ?
                <OverlayTrigger placement='bottom' overlay={
                    <Tooltip id='error'>
                    Pago efectuado
                    </Tooltip>
                }>
                    <div className='factura-estado-icon-container'>
                        <FontAwesomeIcon className='view-icon' icon={faCheckCircle} />
                    </div>
                </OverlayTrigger>
            :
                <OverlayTrigger placement='bottom' overlay={
                    <Tooltip id='error'>
                    Sin pago
                    </Tooltip>
                }>
                    <div className='factura-estado-icon-container-uncheck'>
                        <FontAwesomeIcon className='view-icon' icon={faMinusCircle} />
                    </div>
                </OverlayTrigger>
            }
        </>
    );
}

const FacturasView = (props) => {

    const { dates, onChange, onClick, onExportClick } = props;

    return(
    <div className='page-container'>
        <Title>Facturas</Title>
        <div className='datefields-container'>
            <DateField label="Fecha inicial:" name='date1' value={dates.date1} onChange={onChange} /> 
            <DateField label="Fecha final:" name='date2' value={dates.date2} onChange={onChange} />
            <Button onClick={onClick}>Consultar</Button>
        </div>
        {props.request.loading ?
            <div className='loading-spinner'>
                <Spinner animation="border" variant="primary" />
            </div>
        :
            <div className='page-body'>
                <table className='info-table'>
                    <thead>
                        <tr>
                            <th>NO.</th>
                            <th>FECHA DEL DOCUMENTO</th>
                            <th>CENTRO DE OPERACION</th>
                            <th>DOCUMENTO</th>
                            <th>DOCUMENTO DE CAUSACION</th>
                            <th>VALOR BRUTO</th>
                            <th>VALOR NETO</th>
                            <th>ESTADO</th>
                            <th>VER</th>
                        </tr>
                    </thead>
                    <tbody>
                        { 
                            props.facturas.map(
                                (factura, index) => {
                                    return(
                                        <tr key={index}>
                                            <td>{ index + 1 }</td>
                                            <td>{ formatDateMin(new Date(factura.fechaDoc)) }</td>
                                            <td>{ factura.co }</td>
                                            <td>{ factura.docProv }</td>
                                            <td>{ factura.tipoDoc + '-' + factura.numDoc }</td>
                                            <td>${ formatNumber(factura.totalBruto) }</td>
                                            <td>${ formatNumber(factura.totalNeto) }</td>
                                            <td><IconoEstado estado={factura.estado} /></td>
                                            <td>{ factura.estado && <div className='view-icon-container'><Link to={{ pathname: "" }} onClick={(e) => { props.onViewClick(e, factura) }}><FontAwesomeIcon className='view-icon' icon={faEye} /></Link></div>}</td>
                                        </tr>
                                    );
                                }
                            )
                        }
                    </tbody>
                </table>
            </div>
        }
    </div>
);
}

export default FacturasView;